<template>
  <div class="home">
    <div class="section-1">
      <div class="main home-product">
        <!-- <div class="home-product-title">咕比AI课</div>
        <div class="home-product-subtitle">3-8岁孩子爱学的快乐启蒙课</div> -->
        <a class="home-product-buy-btn" @click="handleBuyCourseClick">
          购买体验课
        </a>
      </div>
    </div>
    <div class="section-2">
      <div class="main">
        <div class="product-defined-img"></div>
        <div class="product-defined-content">
          <div class="product-defined-title">咕比AI课-智能在线素质教育平台</div>
          <div class="product-defined-subtitle">
            咕比AI课是广州六一教育科技有限公司专为3-8岁孩子设计的智能在线素质教育平台，结合
            中国孩子的成长特性，自主研发的游戏式AI教学，鼓励孩子从自主探索到主动学习。为了努力成为国内美术AI课的引领者，咕比AI课致力于通
            过趣味教学让孩子爱上主动学习，从而发现成长的无限可能。
          </div>
        </div>
      </div>
    </div>
    <div class="section-3">
      <div class="main">
        <div class="page-title with-start course-special-title">
          在线学习新模式，专为3-8岁孩子研发
        </div>
        <div class="course-special-list">
          <div class="course-special-item">
            <div class="course-special-title-circle blue">
              <span class="course-special-title-text">科学</span><br />
              <span class="course-special-title-text">体系</span>
            </div>
            <div class="course-special-description">科学分阶的课程体系</div>
            <div class="course-special-paragraph">
              针对各年龄段孩子的成长 特性，分阶段教学，适合 不同起点的孩子
            </div>
          </div>
          <div class="course-special-item">
            <div class="course-special-title-circle pink">
              <span class="course-special-title-text">创新</span><br />
              <span class="course-special-title-text">课堂</span>
            </div>
            <div class="course-special-description">创新的AI动画课堂</div>
            <div class="course-special-paragraph">
              课堂应用AI智能技术，结 合孩子喜欢的情景动画， 让孩子主动学习
            </div>
          </div>
          <div class="course-special-item">
            <div class="course-special-title-circle orange">
              <span class="course-special-title-text">专业</span><br />
              <span class="course-special-title-text">辅导</span>
            </div>
            <div class="course-special-description">专业完善的辅导体系</div>
            <div class="course-special-paragraph">
              专业老师课后1对1点评， 专属社群辅导，全程陪伴 孩子成长
            </div>
          </div>
          <div class="course-special-item">
            <div class="course-special-title-circle green">
              <span class="course-special-title-text">学习</span><br />
              <span class="course-special-title-text">跟进</span>
            </div>
            <div class="course-special-description">智能高效的学习报告</div>
            <div class="course-special-paragraph">
              实时生成学习报告，帮助 家长了解学习情况，及时跟进孩子学习情况
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-4">
      <div class="page-title with-start2 video-intro-title">
        咕比AI课，快乐启蒙教育
      </div>
      <div class="video-wrapper">
        <div class="video-sound">
          <div class="video-sound-equipment active" ref="equipmentOne">
            <div class="video-melody-one"></div>
            <div class="video-melody-two"></div>
            <div class="video-sound-bg"></div>
            <div class="video-sound-circle first"></div>
            <div class="video-sound-circle"></div>
          </div>
        </div>
        <div class="video-container" ref="videoContainer">
          <video
            ref="video"
            :id="videoId"
            class="video video-js vjs-default-skin"
          >
            <source :src="videoUrl" type="video/mp4" />
          </video>
        </div>
        <div class="video-sound">
          <div class="video-sound-equipment active" ref="equipmentTwo">
            <div class="video-melody-one"></div>
            <div class="video-melody-two"></div>
            <div class="video-sound-bg"></div>
            <div class="video-sound-circle first"></div>
            <div class="video-sound-circle"></div>
          </div>
        </div>
      </div>
      <div class="video-extra-title">“咕比美术AI课”首发</div>
      <div class="video-extra-desc">3-8岁在线学画画</div>
    </div>
    <div class="section-5">
      <div class="main">
        <div class="page-title rich-knowledge-title">
          丰富多元的主题课程，带领孩子看世界
        </div>
        <div class="rich-knowledge-list">
          <div class="rich-knowledge-item">
            <div class="rich-knowledge-icon"></div>
            <div class="rich-knowledge-num">450+</div>
            <div class="rich-knowledge-name">绘画作品</div>
          </div>
          <div class="rich-knowledge-item">
            <div class="rich-knowledge-icon"></div>
            <div class="rich-knowledge-num">180+</div>
            <div class="rich-knowledge-name">绘画技巧</div>
          </div>
          <div class="rich-knowledge-item">
            <div class="rich-knowledge-icon"></div>
            <div class="rich-knowledge-num">80+</div>
            <div class="rich-knowledge-name">绘画工具</div>
          </div>
          <div class="rich-knowledge-item">
            <div class="rich-knowledge-icon"></div>
            <div class="rich-knowledge-num">1350+</div>
            <div class="rich-knowledge-name">趣味AI交互</div>
          </div>
          <div class="rich-knowledge-item">
            <div class="rich-knowledge-icon"></div>
            <div class="rich-knowledge-num">100+</div>
            <div class="rich-knowledge-name">名人名画</div>
          </div>
          <div class="rich-knowledge-item">
            <div class="rich-knowledge-icon"></div>
            <div class="rich-knowledge-num">360+</div>
            <div class="rich-knowledge-name">生活知识</div>
          </div>
          <div class="rich-knowledge-item">
            <div class="rich-knowledge-icon"></div>
            <div class="rich-knowledge-num">120+</div>
            <div class="rich-knowledge-name">传统文化</div>
          </div>
          <div class="rich-knowledge-item">
            <div class="rich-knowledge-icon"></div>
            <div class="rich-knowledge-num">150+</div>
            <div class="rich-knowledge-name">天文地理</div>
          </div>
          <div class="rich-knowledge-item">
            <div class="rich-knowledge-icon"></div>
            <div class="rich-knowledge-num">180+</div>
            <div class="rich-knowledge-name">科学知识</div>
          </div>
          <div class="rich-knowledge-item">
            <div class="rich-knowledge-icon"></div>
            <div class="rich-knowledge-num">150+</div>
            <div class="rich-knowledge-name">动物植物</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-6">
      <div class="page-title course-advance-title">
        先进课程体系，科学教学规划
      </div>
      <div class="course-mix">
        <div class="course-mix-1">美国K12国家核心<br />艺术课程标准</div>
        <div class="course-mix-2">咕比美术AI课<br />课程体系</div>
        <div class="course-mix-3">贴合中国家庭孩子<br />的教学目标</div>
      </div>
      <div class="course-upgrade-table">
        <div class="course-gubi"></div>
        <div class="course-arrow-up"></div>
        <div class="course-upgrade-table-thead">
          <div class="course-upgrade-table-td th-col">课程难度</div>
          <div class="course-upgrade-table-td k1">K1</div>
          <div class="course-upgrade-table-td k2">K2</div>
          <div class="course-upgrade-table-td k3">K3</div>
        </div>
        <div class="course-upgrade-table-tr">
          <div class="course-upgrade-table-td th-col">年龄阶段</div>
          <div class="course-upgrade-table-td">3-4岁</div>
          <div class="course-upgrade-table-td">4-6岁</div>
          <div class="course-upgrade-table-td">6-8岁</div>
        </div>
        <div class="course-upgrade-table-tr">
          <div class="course-upgrade-table-td th-col">课程阶段</div>
          <div class="course-upgrade-table-td">启蒙与感知</div>
          <div class="course-upgrade-table-td">探索与表现</div>
          <div class="course-upgrade-table-td">认知与表达</div>
        </div>
        <div class="course-upgrade-table-tr">
          <div class="course-upgrade-table-td th-col auto-height">
            知识模块
          </div>
          <div class="course-upgrade-table-td multi-line">
            图画语言、图形认识、色彩感知、<br />
            位置关系、肌理感受、艺术体验、<br />
            图画符号、图形组合、色彩变化、<br />
            主次关系、肌理探索、艺术感受
          </div>
          <div class="course-upgrade-table-td multi-line">
            绘画元素、图形表达、形色创想、<br />
            画面秩序、肌理表达、艺术欣赏、<br />
            图形创造、创意思维、色彩进阶、<br />
            肌理探究、构图形式、综合探索
          </div>
          <div class="course-upgrade-table-td multi-line">
            绘画表达、图形创想、色彩应用、<br />
            创意表达、造型表现、肌理创作、<br />
            欣赏评述、画面构图、创意进阶、<br />
            造型探索、设计应用、综合探究
          </div>
        </div>
        <div class="course-upgrade-table-tr">
          <div class="course-upgrade-table-td th-col">三大内容板块</div>
          <div class="course-upgrade-table-td colspan3">
            自然认知、百科探索、人文艺术
          </div>
        </div>
        <div class="course-upgrade-table-tr">
          <div class="course-upgrade-table-td th-col">四大教学目标</div>
          <div class="course-upgrade-table-td colspan3">
            知识目标、技能目标、思维目标、情感目标
          </div>
        </div>
        <div class="course-upgrade-table-tr">
          <div class="course-upgrade-table-td th-col">五大能力提升</div>
          <div class="course-upgrade-table-td colspan3">
            手脑协调能力、想象力、观察力、创造力、艺术审美力
          </div>
        </div>
      </div>
    </div>
    <div class="section-7" ref="chainContainer">
      <div class="page-title learning-chain-title">
        AI互动模式+三段式闭环学习，创新教学模式助力孩子高效成长
      </div>
      <div class="learning-chain-desc">
        咕比AI课创新教学模式，专业研发AI互动技术，培养孩子的好奇心，培养孩子的专注力，提高孩子的积极性
        潜移默化的形成良好的学习习惯。同时有效的教学闭环帮助孩子最大化提升学习效率，高速成长。
      </div>
      <div class="learning-chain-container">
        <div class="before-class" :class="{ active: showCircle }">
          <div class="learning-chain-img"></div>
          <div class="learning-chain-text">课前预习引导</div>
        </div>
        <div class="after-class" :class="{ active: showCircle }">
          <div class="learning-chain-img"></div>
          <div class="learning-chain-text">课后迅速反馈</div>
        </div>
        <div class="class-interactive" :class="{ active: showCircle }">
          <div class="learning-chain-img"></div>
          <div class="learning-chain-text">课中高频互动</div>
        </div>
        <div class="ai-class-circle" :class="{ active: showCircle }">
          <div class="ai-circle-img"></div>
          <div class="ai-circle-line-one">AI课程</div>
          <div class="ai-circle-line-two">闭环学习</div>
        </div>
      </div>
    </div>
    <div class="section-8">
      <div class="page-title professor-group-title">
        资深专业教研团队，为孩子学习成长保驾护航
      </div>
      <div class="professor-group-desc">
        AI课教研团队汇集来自全国八大美院、知名高等学府及海外知名院校的专业美术教育工作者，
        儿童教育及儿童心理辅导工作者，自然科学、人文历史等专业教育工作者，精准针对3-8岁孩
        子身心发展特点，打造出进阶式咕比美术AI课课程体系，助力孩子在美术学习路上茁壮成长。
      </div>
      <div class="professor-group-img"></div>
    </div>
    <div class="section-9">
      <div class="page-title learning-tools-title">
        配套精美画具，孩子上课更省心
      </div>
      <div class="learning-tools-desc">
        课程配套教具，画具包包邮到家，家长免去采购画具的麻烦。孩子亲自动手完成每一节课的预习、上课、创作。家长少操心，孩子学习更主动。
      </div>
      <div class="course-gallery">
        <div class="course-gallery-display" :class="[currentGallery]"></div>
        <div class="course-gallery-slider-outer">
          <div class="course-gallery-slider">
            <div
              class="course-gallery-thumbnail k2-s"
              :class="{ active: currentGallery === 'k2-s' }"
              @mouseenter="handleThumbnailHover('k2-s')"
              title="k2系统课画具"
            ></div>
            <div
              class="course-gallery-thumbnail k3-s"
              :class="{ active: currentGallery === 'k3-s' }"
              @mouseenter="handleThumbnailHover('k3-s')"
              title="k3系统课画具"
            ></div>
            <div
              class="course-gallery-thumbnail k3-e"
              :class="{ active: currentGallery === 'k3-e' }"
              @mouseenter="handleThumbnailHover('k3-e')"
              title="k3体验课画具"
            ></div>
            <div
              class="course-gallery-thumbnail k2-e"
              :class="{ active: currentGallery === 'k2-e' }"
              @mouseenter="handleThumbnailHover('k2-e')"
              title="k2体验课画具"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-10">
      <div class="page-title learning-promise-title">多重承诺，安心有保障</div>
      <div class="learning-promise-list">
        <div class="learning-promise-item">
          <div class="learning-promise-img quality"></div>
          <div>
            <div class="learning-promise-item-title">品质保障</div>
            <div class="learning-promise-subtitle">课程和教学质量</div>
            <div class="learning-promise-subtitle">严格审核把关</div>
          </div>
        </div>
        <div class="learning-promise-item">
          <div class="learning-promise-img gift"></div>
          <div>
            <div class="learning-promise-item-title">配套画具</div>
            <div class="learning-promise-subtitle">全国包邮配套</div>
            <div class="learning-promise-subtitle">教辅画具包</div>
          </div>
        </div>
        <div class="learning-promise-item">
          <div class="learning-promise-img professional"></div>
          <div>
            <div class="learning-promise-item-title">专业师资</div>
            <div class="learning-promise-subtitle">各大美术院校</div>
            <div class="learning-promise-subtitle">名师授课</div>
          </div>
        </div>
        <div class="learning-promise-item">
          <div class="learning-promise-img review"></div>
          <div>
            <div class="learning-promise-item-title">支持回放</div>
            <div class="learning-promise-subtitle">支持课程内容</div>
            <div class="learning-promise-subtitle">观看学习</div>
          </div>
        </div>
        <div class="learning-promise-item">
          <div class="learning-promise-img flexible"></div>
          <div>
            <div class="learning-promise-item-title">时间灵活</div>
            <div class="learning-promise-subtitle">用手机就可以</div>
            <div class="learning-promise-subtitle">随时随地在家学</div>
          </div>
        </div>
        <div class="learning-promise-item">
          <div class="learning-promise-img service"></div>
          <div>
            <div class="learning-promise-item-title">人工客服</div>
            <div class="learning-promise-subtitle">7×24小时</div>
            <div class="learning-promise-subtitle">人工客服答疑</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-11">
      <div class="main">
        <div class="page-title quota-title">资本护航，实力保证</div>
        <div class="investor-list main">
          <div class="investor-item zhenge">
            <div class="investor-name">真格基金</div>
            <div class="investor-desc">中国早期投资机构第一名</div>
          </div>
          <div class="investor-item haoweilai">
            <div class="investor-name">好未来(学而思)</div>
            <div class="investor-desc">国内知名教育集团</div>
          </div>
          <div class="investor-item jingwei">
            <div class="investor-name">经纬创投</div>
            <div class="investor-desc">美国历史悠久的投资基金</div>
          </div>
          <div class="investor-item legao">
            <div class="investor-name">乐高创新投资基金</div>
            <div class="investor-desc">享誉全球的品牌</div>
          </div>
          <div class="investor-item qicheng">
            <div class="investor-name">启承资本</div>
            <div class="investor-desc">知名私募股权成长基金</div>
          </div>
          <div class="investor-item qiming">
            <div class="investor-name">启明创投</div>
            <div class="investor-desc">顶级美元风险投资公司</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-12" ref="buyCourseAnchor" v-if="!isAd">
      <div class="main">
        <div>
          <div class="home-course-card">
            <div class="home-course-card-tag">限时特惠 新人专享</div>
            <div class="home-course-card-content">
              <div class="home-course-card-title">咕比美术AI课-体验课</div>
              <div class="home-course-card-subtitle">
                配套教材+1对1辅导+支持回放
              </div>
              <div class="home-course-price">
                <span class="home-course-price-discount">¥29</span>
                <span class="home-course-price-origin">原价399元</span>
              </div>
            </div>
            <div class="home-course-qrcode">
              <div class="home-course-qrcode-img"></div>
              <div class="home-course-qrcode-tips">打开微信，扫一扫</div>
            </div>
          </div>
        </div>
        <div>
          <div class="home-course-text">
            <div class="home-course-text-title">扫码报名，即刻体验</div>
            <div class="home-course-text-item">
              8节美术AI互动课+2节美术名师TV课
            </div>
            <div class="home-course-text-item">AI互动+动画教学+名师点评</div>
            <div class="home-course-text-item">配套199元教辅画具包</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Home from './index'
export default Home
</script>

<style lang="scss">
@import './index.scss';
</style>
